import { AnyAction, isType } from 'typescript-fsa';
import { UserGroupTournamentSubscription } from '../../../services/betting';
import { ugtsSetEntities } from './actions';

export interface UserGroupTournamentSubscriptionState {
    tournamentSubscriptions: UserGroupTournamentSubscription[];
}

const initialUserGroupTournamentSubscriptionState: UserGroupTournamentSubscriptionState = {
    tournamentSubscriptions: []
};

export function userGroupTournamentSubscriptionStateReducer(
    state: UserGroupTournamentSubscriptionState = initialUserGroupTournamentSubscriptionState,
    action: AnyAction
): UserGroupTournamentSubscriptionState {
    if (isType(action, ugtsSetEntities)) {
        return { ...state, tournamentSubscriptions: action.payload };
    }

    return state;
}
